import { render, staticRenderFns } from "./DepositPayableTypeView.vue?vue&type=template&id=2adc9588&scoped=true&"
import script from "./DepositPayableTypeView.vue?vue&type=script&lang=ts&"
export * from "./DepositPayableTypeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc9588",
  null
  
)

export default component.exports